/* Wishlist Plus (Swym) bridge.

   The theme draws its own hearts — .fav.favcard on product cards and .fav in the
   product page buy row. This file makes those hearts drive Swym instead of the
   localStorage list bubbly.js used to keep, so a save follows the customer's
   account rather than their browser. It also fills the wishlist drawer.

   How the old handlers are retired, without editing bubbly.js:
   - Cards: product-card.liquid marks the button data-wish instead of
     data-fav-card, so bubbly.js's delegated listener no longer matches it.
   - Product page: main-product.liquid attaches its handler directly to the
     button, so replacing the node with a clone drops that listener.

   Clicks are caught in the CAPTURE phase and bound immediately rather than
   inside the Swym callback, so neither bubbly.js nor Swym's own scripts can
   swallow a click before this file sees it, and the drawer's buttons work even
   if the SDK is slow to arrive.

   Swym has shipped several SDK generations with different method names, so every
   read and write tries the known aliases in turn. window.BubblyWish.debug()
   reports which ones your installed version actually exposes. */
(function () {
  var ET = 4; // Swym event type for a wishlist save
  var swat = null;
  var state = {};
  var items = [];

  function keyOf(empi, epi) { return String(empi) + ':' + String(epi); }
  function $(s) { return document.querySelector(s); }

  /* Pick the first method that exists, from a list of names Swym has used. */
  function pick(names) {
    if (!swat) return null;
    for (var i = 0; i < names.length; i++) {
      if (typeof swat[names[i]] === 'function') return names[i];
    }
    return null;
  }

  var ADD_NAMES = ['addToWishList', 'addToWishlist', 'addProductToWishlist'];
  var DEL_NAMES = ['deleteFromWishList', 'deleteFromWishlist', 'removeFromWishList', 'removeFromWishlist', 'deleteFromList'];
  var READ_NAMES = ['fetchWrtEventTypeET', 'fetch', 'retrieveAll', 'fetchList'];

  /* ---------- reading item data off a button ---------- */

  function cardData(btn) {
    return {
      empi: Number(btn.dataset.empi),
      epi: Number(btn.dataset.epi),
      du: btn.dataset.du,
      dt: btn.dataset.dt || '',
      iu: btn.dataset.iu || '',
      pr: Number(btn.dataset.pr || 0),
      et: ET
    };
  }

  /* The product page button carries only the product id, so the variant comes
     from the section's hidden variant select — that way saving a mat records the
     material the customer actually had chosen. */
  function pdpData(btn) {
    var sel = $('[data-variant-select]');
    var epi = sel && sel.value ? Number(sel.value) : null;
    if (window.SwymPageData && window.SwymPageData.empi) {
      var d = {};
      for (var k in window.SwymPageData) {
        if (Object.prototype.hasOwnProperty.call(window.SwymPageData, k)) d[k] = window.SwymPageData[k];
      }
      d.et = ET;
      if (epi) d.epi = epi;
      return d;
    }
    var title = $('.pdp .info h1');
    var shot = $('[data-main-image]');
    return {
      empi: Number(btn.dataset.fav),
      epi: epi,
      du: window.location.origin + window.location.pathname,
      dt: title ? title.textContent.trim() : document.title,
      iu: shot ? shot.getAttribute('src') : '',
      et: ET
    };
  }

  function dataFor(btn) {
    return btn.hasAttribute('data-wish') ? cardData(btn) : pdpData(btn);
  }

  /* ---------- painting hearts and the count ---------- */

  function setOn(btn, on) {
    btn.classList.toggle('on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('[data-fav-label]');
    if (label) {
      if (!label.dataset.saveText) label.dataset.saveText = label.textContent.trim();
      label.textContent = on ? (btn.dataset.savedLabel || 'Saved') : label.dataset.saveText;
    }
  }

  function paintCount() {
    var n = items.length;
    var dots = document.querySelectorAll('[data-wish-dot]');
    for (var i = 0; i < dots.length; i++) {
      if (n > 0) dots[i].removeAttribute('hidden'); else dots[i].setAttribute('hidden', '');
    }
    var outs = document.querySelectorAll('[data-wish-count]');
    for (var j = 0; j < outs.length; j++) outs[j].textContent = n;
  }

  function paintHearts() {
    var cards = document.querySelectorAll('[data-wish]:not([data-wish-line])');
    for (var i = 0; i < cards.length; i++) {
      var d = cardData(cards[i]);
      setOn(cards[i], !!state[keyOf(d.empi, d.epi)]);
    }
    var pdp = $('[data-fav]');
    if (pdp) {
      var p = pdpData(pdp);
      setOn(pdp, !!state[keyOf(p.empi, p.epi)]);
    }
  }

  function paint() {
    paintHearts();
    paintCount();
    renderDrawer();
  }

  /* ---------- the drawer ---------- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function money(n, symbol) {
    var v = Number(n || 0);
    if (!v) return '';
    return symbol + v.toFixed(2).replace(/\.00$/, '');
  }

  /* Swym's item shape varies; the variant id has appeared under several keys. */
  function variantOf(it) {
    return it.epi || it.variantId || it.variant_id || (it.variants && it.variants[0] && it.variants[0].id) || null;
  }

  function line(it, copy) {
    var url = it.du || '#';
    var title = esc(it.dt || '');
    var price = money(it.pr, copy.symbol);
    var epi = variantOf(it);
    return '<div class="wline">' +
      '<a class="wlph" href="' + esc(url) + '">' +
        (it.iu ? '<img src="' + esc(it.iu) + '" alt="' + title + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="wlinfo">' +
        '<a class="wlname" href="' + esc(url) + '">' + title + '</a>' +
        (price ? '<span class="wlprice">' + price + '</span>' : '') +
        '<div class="wlacts">' +
          (epi
            ? '<button type="button" class="wladd" data-wish-add="' + esc(epi) + '">' + esc(copy.add) + '</button>'
            : '<span class="wlgone">' + esc(copy.gone) + '</span>') +
          '<button type="button" class="wlrm" data-wish-line data-wish' +
            ' data-empi="' + esc(it.empi) + '" data-epi="' + esc(epi) + '"' +
            ' data-du="' + esc(url) + '" data-dt="' + title + '"' +
            ' data-iu="' + esc(it.iu || '') + '" data-pr="' + esc(it.pr || 0) + '">' + esc(copy.remove) +
          '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderDrawer() {
    var shell = $('[data-wish-copy]');
    if (!shell) return;
    var lines = shell.querySelector('[data-wish-lines]');
    var empty = shell.querySelector('[data-wish-empty]');
    var foot = shell.querySelector('[data-wish-foot]');
    if (!lines) return;

    var copy = {
      add: shell.dataset.add || 'Add to bag',
      remove: shell.dataset.remove || 'Remove',
      gone: shell.dataset.gone || 'Sold out',
      symbol: shell.dataset.symbol || '$'
    };

    if (!items.length) {
      lines.innerHTML = '';
      lines.hidden = true;
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }

    lines.innerHTML = items.map(function (it) { return line(it, copy); }).join('');
    lines.hidden = false;
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;
  }

  function openDrawer() {
    var s = $('[data-wish-scrim]');
    if (!s) return;
    s.classList.add('open');
    if (swat) refresh();
    else say('We could not reach your saved pieces just now. Please refresh.');
  }
  function closeDrawer() {
    var s = $('[data-wish-scrim]');
    if (s) s.classList.remove('open');
  }
  function say(text) {
    var msg = $('[data-wish-loading]');
    if (msg) msg.textContent = text;
  }

  /* ---------- reading and writing Swym ---------- */

  function loadState(done) {
    done = done || function () {};
    if (!swat) return done();
    var apply = function (list) {
      items = (list || []).filter(function (it) { return it && it.empi; });
      state = {};
      items.forEach(function (it) { state[keyOf(it.empi, variantOf(it))] = true; });
      done();
    };
    var name = pick(READ_NAMES);
    try {
      if (name === 'fetchWrtEventTypeET') { swat[name](apply, ET, done); return; }
      if (name) {
        swat[name](function (res) {
          /* Either a flat array of items or a set of lists. */
          if (Array.isArray(res) && res.length && res[0] && res[0].empi) return apply(res);
          var out = [];
          (res || []).forEach(function (l) {
            (l.listcontents || l.items || []).forEach(function (i) { out.push(i); });
          });
          apply(out);
        }, done);
        return;
      }
    } catch (e) {}
    done();
  }

  function refresh() { loadState(paint); }

  function toggle(btn) {
    if (!swat || btn.dataset.wishBusy === '1') return;
    var d = dataFor(btn);
    if (!d || !d.empi || !d.epi) return;
    var on = !!state[keyOf(d.empi, d.epi)];

    /* Paint immediately so the heart answers the tap, then reconcile against
       whatever Swym actually stored. */
    if (!btn.hasAttribute('data-wish-line')) setOn(btn, !on);
    btn.dataset.wishBusy = '1';
    btn.classList.add('wbusy');

    var settled = false;
    var settle = function () {
      if (settled) return;
      settled = true;
      btn.dataset.wishBusy = '';
      btn.classList.remove('wbusy');
      refresh();
    };
    /* A callback Swym never fires must not leave the button dead. */
    setTimeout(settle, 5000);

    var name = pick(on ? DEL_NAMES : ADD_NAMES);
    if (!name) {
      settle();
      return;
    }
    try { swat[name](d, settle, settle); } catch (e) { settle(); }
  }

  /* Add to bag. fetch resolves on HTTP errors too, so the status is checked and
     a real form post is used as a fallback. */
  function addToBag(btn) {
    var id = Number(btn.dataset.wishAdd);
    if (!id) return;
    btn.disabled = true;

    var handOff = function () {
      btn.disabled = false;
      closeDrawer();
      var cartBtn = $('[data-cart-open]');
      if (cartBtn) cartBtn.click();
    };

    var formPost = function () {
      var f = document.createElement('form');
      f.method = 'post';
      f.action = '/cart/add';
      f.style.display = 'none';
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'id'; i.value = String(id);
      var q = document.createElement('input');
      q.type = 'hidden'; q.name = 'quantity'; q.value = '1';
      f.appendChild(i); f.appendChild(q);
      document.body.appendChild(f);
      f.submit();
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (r.ok) { handOff(); return; }
      btn.disabled = false;
      formPost();
    }).catch(function () {
      btn.disabled = false;
      formPost();
    });
  }

  /* ---------- events ---------- */

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-wish-open]')) { e.preventDefault(); e.stopPropagation(); openDrawer(); return; }
    if (t.closest('[data-wish-close]')) { e.preventDefault(); e.stopPropagation(); closeDrawer(); return; }
    if (t.matches && t.matches('[data-wish-scrim]')) { closeDrawer(); return; }

    var add = t.closest('[data-wish-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); addToBag(add); return; }

    var btn = t.closest('[data-wish], [data-fav]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }

  /* Capture phase, bound now rather than inside the Swym callback, so no other
     script can consume the click first. */
  document.addEventListener('click', onClick, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (s) {
    swat = s;

    /* Retire the product page's own click handler by swapping in a clone. */
    var pdp = $('[data-fav]');
    if (pdp && !pdp.dataset.wishUpgraded && pdp.parentNode) {
      var clone = pdp.cloneNode(true);
      clone.dataset.wishUpgraded = '1';
      pdp.parentNode.replaceChild(clone, pdp);
    }

    /* Swym's own UI can change the list too, so repaint when it says so. */
    try {
      if (s.evtLayer && s.JSEvents) {
        [s.JSEvents.addedToWishlist, s.JSEvents.removedFromWishlist].forEach(function (ev) {
          if (ev) s.evtLayer.addEventListener(ev, refresh);
        });
      }
    } catch (e) {}

    /* Cards arrive after load from quick shop and section rendering. */
    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(paintHearts, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }

    refresh();
  });

  window.BubblyWish = {
    refresh: refresh,
    open: openDrawer,
    close: closeDrawer,
    items: function () { return items.slice(); },
    state: function () { return state; },
    /* Paste the output of this into chat if something misbehaves. */
    debug: function () {
      return {
        sdkLoaded: !!swat,
        readMethod: pick(READ_NAMES),
        addMethod: pick(ADD_NAMES),
        deleteMethod: pick(DEL_NAMES),
        savedCount: items.length,
        firstItem: items[0] || null,
        variantOfFirst: items[0] ? variantOf(items[0]) : null,
        drawerPresent: !!$('[data-wish-copy]'),
        addButtons: document.querySelectorAll('[data-wish-add]').length
      };
    }
  };
})();
